<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
        		<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormFactura" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
									<label class="form-label" for="NombreCliente">Cliente</label>
									<div class="input-group">
										<input type="text" v-model="objFactura.NombreCliente" class="form-control" id="NombreCliente" placeholder="Ingresar NombreCliente" readonly/>
										<button type="button" @click="RefrescarDataCliente()" class="btn btn-outline-primary boder-extend" id="button-addon2">
											<i class="fa fa-redo"></i>
										</button>
									</div>
									<CValidation v-if="this.errorvalidacion.NombreCliente" :Mensaje="'*'+errorvalidacion.NombreCliente[0]"/>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
									<label class="form-label" for="RFC">RFC</label>
									<input type="text" v-model="objFactura.RfcCliente" class="form-control" id="RFC" placeholder="Ingresar RFC" readonly />
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio Cotización</label>
									<input type="text" v-model="objAgenos.FolioCotizacion" class="form-control" id="Folio" placeholder="Ingresar Folio" readonly />
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<label class="form-label" for="Folio">Folio Factura</label>
									<input type="text" class="form-control" id="Folio" placeholder="Ingresar Folio" :value="objFactura.Serie+'-'+objFactura.Folio" readonly />
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
									<span>Regimen Fiscal: <b>{{$cambiarGuion(objFactura.RegimenFiscalCliente)}}</b></span><br>
									<span>Calle: <b>{{objFactura.CalleCliente}}</b>, N° Ext. <b>{{objFactura.NumExtCliente}}</b>, Colonia: <b>{{objFactura.ColoniaCliente}}</b>, Código Postal: <b>{{objFactura.CPCliente}}</b></span><br>
									<span>Pais: <b>{{objFactura.PaisCliente}}</b>, Estado: <b>{{objFactura.EstadoCliente}}</b>, Municipio: <b>{{objFactura.CiudadCliente}}</b></span>
								</div>
							</div>
	
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="CondicionesPago">Condición de pago</label>
									<select v-model="objFactura.CondicionesPago" @change="SetearACredito()" class="form-control form-select" id="CondicionesPago">
										<option value="">Seleccione una opción</option>
										<option value="CONTADO">Contado</option>
										<option value="CREDITO">Crédito</option>
									</select>
									<CValidation v-if="this.errorvalidacion.CondicionesPago" :Mensaje="'*'+errorvalidacion.CondicionesPago[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="MetodoPago">Método de pago:</label>
									<select v-model="objFactura.MetodoPago" class="form-control form-select" id="MetodoPago">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaMetodoPago" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.MetodoPago" :Mensaje="'*'+errorvalidacion.MetodoPago[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label for="FormaPago">Forma de pago</label>
									<select v-model="objFactura.FormaPago" class="form-control form-select" id="FormaPago">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaFormaPago" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.FormaPago" :Mensaje="'*'+errorvalidacion.FormaPago[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="UsoCfdi">Uso CFDI</label>
									<select v-model="objFactura.UsoCfdi" class="form-control form-select" id="UsoCfdi">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaUsodeCfdi" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<Cvalidation v-if="this.errorvalidacion.UsoCfdi" :Mensaje="'*'+errorvalidacion.UsoCfdi[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="Moneda">Moneda</label>
									<select v-model="objFactura.Moneda" class="form-control form-select" id="Moneda">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaMonedas" :key="index" :value="item.Clave">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<CValidation v-if="this.errorvalidacion.Moneda" :Mensaje="'*'+errorvalidacion.Moneda[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<label class="" for="TipoCambio">Tipo de Cambio</label>
									<input type="text" v-model="objFactura.TipoCambio" @input="$number_decimal($event,objFactura,'TipoCambio');" id="TipoCambio" class="form-control">
									<CValidation v-if="this.errorvalidacion.TipoCambio" :Mensaje="'*'+errorvalidacion.TipoCambio[0]"/>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<h5>Descuentos</h5>
								</div>
							</div>
							

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<div class="row">
										<label class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-2" for="PorcentajeComision">% Comisión</label>
										
										<div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3">
											<input type="text" v-model="objFactura.PorcentajeComision" class="form-control" id="PorcentajeComision" placeholder="%" readonly />
											<Cvalidation v-if="this.errorvalidacion.PorcentajeComision" :Mensaje="'*'+errorvalidacion.PorcentajeComision[0]"/>
										</div>

										<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
											<div class="form-check">
												<input class="form-check-input" type="checkbox" v-model="objFactura.AplicaComision" @change="CalculaTipoCambioUsd()" value="" id="flexCheckDefault">
												<label class="form-check-label" for="flexCheckDefault">
													Aplicar
												</label>
											</div>
										</div>

									</div>
								</div>
								
								<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
									<div class="row">
										<label class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-2" for="ComisionFlores">% Floreria</label>

										<div class="col-6 col-sm-6 col-md-6 col-lg-3 col-xl-3">
											<input type="text" v-model="objFactura.ComisionFlores" class="form-control" id="ComisionFlores" placeholder="%" readonly />
											<Cvalidation v-if="this.errorvalidacion.ComisionFlores" :Mensaje="'*'+errorvalidacion.ComisionFlores[0]"/>
										</div>

										<div class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-4">
											<div class="form-check">
												<input class="form-check-input" type="checkbox" v-model="objFactura.AplicaComFlor" @change="CalculaTipoCambioUsd();" value="" id="flexCheckDefault2">
												<label class="form-check-label" for="flexCheckDefault2">
													Aplicar
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<h5>Documentos Relacionados</h5>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
									<label class="" for="TipoRelacion">Tipo de relación</label>
									<select v-model="objFactura.TipoRelacion" class="form-control form-select" id="TipoRelacion">
										<option value="">Seleccione una opción</option>
										<option v-for="(item,index) in ListaTipoRelacion" :key="index" :value="item.Clave+'~'+item.Nombre">
											{{item.Clave+' - '+item.Nombre}}
										</option>
									</select>
									<Cvalidation v-if="this.errorvalidacion.TipoRelacion" :Mensaje="'*'+errorvalidacion.TipoRelacion[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
									<div class="btn-group mb-0 mt-1" role="group" aria-label="basic">
										<button v-if="objFactura.TipoRelacion!=''" type="button" @click="AbrirModalRelacionadas();" class="btn btn-primary mb-0 mt-4" v-b-tooltip.hover.Top title="Facturas Relacionadas">
											<i class="fa fa-plus-circle"></i> Facturas
										</button>

										<button v-if="ListaDocsRelacionados.length>0" type="button" @click="BorrarRelacionadas();" class="btn btn-primary mb-0 mt-4">
											<i class="fa fa-trash"></i> Borrar Todas
										</button>
									</div>
								</div>
								
							</div>

							<div class="form-group row">
								<div v-for="(item,index) in ListaDocsRelacionados" :key="index" class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
									<div class="row">
										<div class="col-12 mb-2">
											<input type="text" v-model="item.TipoDeRelacion" class="form-control" readonly>
										</div>
									</div>

									<div class="input-group mb-3">
										<input type="text" v-model="item.UUID" class="form-control">
										<button type="button" @click="BorrarItemRelacionada(index)" class="btn btn-outline-danger boder-extend" id="button-addon2">
											<i class="fa fa-trash"></i>
										</button>
									</div>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-8 col-lg-2 col-xl-2">
									<h5>Conceptos</h5>
								</div>

								<div class="col-12 col-sm-12 col-md-8 col-lg-3 col-xl-3">
									<div class="form-check form-check-inline" v-show="objFactura.IdFactura==0">
										<input type="radio" v-model="objFactura.TipoFacturaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="MXN" id="CheckMoneda1">
										<label class="form-check-label" for="CheckMoneda1">
											MXN
										</label>
									</div>

									<div class="form-check form-check-inline" v-show="objFactura.IdFactura==0">
										<input type="radio" v-model="objFactura.TipoFacturaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="USD" id="CheckMoneda2">
										<label class="form-check-label" for="CheckMoneda2">
											USD
										</label>
									</div>

									<div class="form-check form-check-inline" v-show="objFactura.IdFactura==0">
										<input type="radio" v-model="objFactura.TipoFacturaMoneda" @change="GetConceptosCotizacion()" class="form-check-input" name="rbtipo[]" value="" id="CheckMoneda3">
										<label class="form-check-label" for="CheckMoneda3">
											Todos
										</label>
									</div>
								</div>

								<div class="col-12 col-sm-12 col-md-8 col-lg-3 col-xl-3">
									<div class="row">
										<label class="col-form-label col-12 col-sm-12 col-md-8 col-lg-5 col-xl-5">
											Tipo Cambio
										</label>
										<div class="col-12 col-sm-12 col-md-8 col-lg-5 col-xl-5">
											<input type="text" v-model="objFactura.ValorDolar" @input="$number_decimal($event,objFactura,'ValorDolar');CalculaTipoCambioUsd()" class="form-control form-control-sm">
										</div>
									</div>
								</div>

								<div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-end">
									<button type="button" @click="AgregarConcepto()" class="btn btn-primary">
										<i class="fa fa-plus-circle"></i> Concepto
									</button>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<CLoader :pConfigLoad="ConfigLoadTable">
								<template slot="BodyFormLoad">
									<div class="table-responsive pb-0">
										<table class="table table-striped mb-0">
											<thead>
												<tr>
													<th width="3%">#</th>
													<th width="7%">Ret. Iva ({{objAgenos.RetencionIva}}%)</th>
													<th width="5%">Cantidad</th>
													<th width="13%"></th>
													<th width="14%">Seleccione</th>
													<th width="29%">Descripción</th>
													<th width="9%">Precio U.</th>
													<th width="4%">Descuento</th>
													<th width="13%">Importe</th>
													<th width="3%">*</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item,index) in ListaConceptosFactura" :key="index">
													<td>{{(index+1)}}</td>
													<td>
														<div class="form-check">
															<input type="checkbox" v-model="item.RetencionIva" @change="EjecutarCalculos()" :id="'flexCheckDefault_'+index" class="form-check-input">
															<label class="form-check-label" :for="'flexCheckDefault_'+index">
																Aplicar
															</label>
														</div>
													</td>
													<td>
														<input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Clave Servicios</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Clave Unidad</span>
															</div>
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
																<span>Objeto Impuesto</span>
															</div>
														</div>
													</td>
													<td>
														<div class="row">
															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<select v-model="item.ClaveProdServ" @change="CalculaTipoCambioUsd();" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaClavePyS" :key="index2" :value="item2.Clave">
																		{{item2.Clave+' - '+item2.Nombre}}
																	</option>
																</select>
															</div>

															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1">
																<select v-model="item.Unidad" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaUnidadMedida" :key="index2" :value="item2.Clave+'~'+item2.Nombre">
																		{{item2.Nombre}}
																	</option>
																</select>
															</div>

															<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
																<select v-model="item.ClaveObjImpuesto" class="form-control form-select">
																	<option value="">Seleccione</option>
																	<option v-for="(item2,index2) in ListaObjetoImp" :key="index2" :value="item2.Clave">
																		{{item2.Clave+' - '+item2.Nombre}}
																	</option>
																</select>
															</div>
														</div>
													</td>
													<td>
														<textarea v-model="item.Descripcion" class="form-control" rows="3"></textarea>
													</td>
													<td>
														<input type="text" v-model="item.Precio" @input="$number_decimal($event,item,'Precio');EjecutarCalculos();" class="form-control form-control-sm" :readonly="(item.IdDetalleCotizacion>0)?true:false">
													</td>
													<td>
														<input type="text" v-model="item.Descuento" @input="$number_decimal($event,item,'Descuento');EjecutarCalculos()" class="form-control form-control-sm">
													</td>
													<td>
														<input type="text" v-model="item.Importe" class="form-control form-control-sm" readonly>
													</td>
													<td>
														<button type="button" @click="BorrarItemConcepto(index)" class="btn btn-danger btnpequenio">
															<i class="fa fa-trash"></i>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<CValidation v-if="this.errorvalidacion.ArregloEventos" :Mensaje="'*'+errorvalidacion.ArregloEventos[0]"/>
								</template>
								</CLoader>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 mb-2">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objFactura.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<Cvalidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4">
									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Descuento">Descuento:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objFactura.Descuento" class="form-control form-control-sm" id="Descuento" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="SubTotal">SubTotal:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objFactura.SubTotal" class="form-control form-control-sm" id="SubTotal" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="ImporteT">Importe:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objAgenos.Importe" class="form-control form-control-sm" id="ImporteT" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Iva">I.V.A {{objAgenos.TrasladoIva}}%:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objFactura.Iva" class="form-control form-control-sm" id="Iva" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="RetencionIva">Ret. I.V.A ({{objAgenos.RetencionIva}}%):</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objFactura.RetencionIva" class="form-control form-control-sm" id="RetencionIva" readonly>
										</div>
									</div>

									<div class="row">
										<div class="col-4 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-end">
											<label for="Total">Total:</label>
										</div>
										<div class="col-8 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-1">
											<input type="text" v-model="objFactura.Total" class="form-control form-control-sm" id="Total" readonly>
										</div>
									</div>
								</div>
							</div>

							<div class="row justify-content-end mt-4 mb-4">
								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 text-end mt-2">
									<span :class="['badge', (NumeroTimbres>0)?'bg-primary':'bg-danger']">Timbres Disponibles: {{NumeroTimbres}}</span>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
									<select v-model="objAgenos.Guardar" class="form-contorl form-select">
										<option value="1">Guardar</option>
										<template v-if="objFactura.Facturado =='NO'">
											<template v-if="(NumeroTimbres>0)">
												<option value="2">Guardar y Facturar</option>
											</template>
										</template>
									</select>
								</div>
							</div>

							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
					
						</form>
						<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
							<template slot="Form">
								<ListRelacionados :poBtnSave="oBtnSave2"></ListRelacionados>
							</template>
						</CModal>
                    </div>
				</template>
    		</CLoader>
		</template>
	</CList>
   
</template>
<script>
import ListRelacionados from '@/views/modulos/finanzas/facturas/ListRelacionados.vue';

const EmitEjecuta = 'seccionFactura';
const EmitEjecuta2 = 'seccionRelacionadas';

export default {
    name: 'FormFactura',
    props: ['Id','Obj'],
    components:{
		ListRelacionados,
    },
    data() {
        return {
			ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'factura',
                EmitSeccion: EmitEjecuta,
				ActiveEmitReturn: true,
				ShowBtnSave: false,
            },
			ConfigModal2:{
                ModalTitle: "Facturas Relacionadas",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'xl',
				ShowFooter: false,
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
			ConfigLoadTable:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objFactura: {
				IdFactura: 0,
				IdCotizacion: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				NombreEmpresa: '',
				RegimenFiscalEmpresa: '',
				RfcEmpresa: '',
				CalleEmpresa: '',
				TelEmpresa: '',
				ColoniaEmpresa: '',
				CiudadEmpresa: '',
				PaisEmpresa: '',
				EstadoEmpresa: '',
				MunicipioEmpresa: '',
				CPEmpresa: '',
				NumExtEmpresa: '',
				NumIntEmpresa: '',
				NombreCliente: '',
				RfcCliente: '',
				TelCliente: '',
				CorreoCliente: '',
				CalleCliente: '',
				ColoniaCliente: '',
				CiudadCliente: '',
				PaisCliente: '',
				EstadoCliente: '',
				MunicipioCliente: '',
				CPCliente: '',
				NumExtCliente: '',
				NumIntCliente: '',
				TipoComprobante: 'I',
				SubTotal: '',
				Descuento: '',
				Iva: '',
				PorcentajeIva: '',
				Total: '',
				FormaPago: '',
				ClavePago: '',
				MetodoPago: '',
				CondicionesPago: '',
				NumCtaPago: '',
				Banco: '',
				TipoCambio: '',
				Moneda: '',
				Simbolo: '$',
				Facturado: 'NO',
				NoProveedor: '',
				Adenda: '',
				Observaciones: '',
				UsoCfdi: '',
				DiasCredito: '',
				Anticipo: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				TipoFacturaMoneda: 'MXN',
				ValorDolar: 0,
				PorcentajeComision: '',
				AplicaComision: '',
				FacturaPaquete: '',
				EstatusCancel: '',
				ComisionFlores: '',
				AplicaComFlor: '',
				RetencionIva: '',
				RegimenFiscalCliente: '',
				VersionFact: '4.0',
				Periodicidad: '',
				MesPeriodicidad: '',
				AnioPeriodicidad: '',
				RegEstatus: 'A',
            },
			objAgenos: {
				Guardar: 1,
				FolioCotizacion: '',
				Importe: '',
				RetencionIva: 6,
				ValorRetencion: 0,
				TrasladoIva: 16,
				ValorIva: 0,
				ClaveFloreria: '',
				ClaveMontaje: '',
			},
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
			ListaMetodoPago: [],
			ListaFormaPago: [],
			ListaUsodeCfdi: [],
			ListaMonedas: [],
			ListaTipoRelacion: [],
			ListaClavePyS: [],
			ListaUnidadMedida: [],
			ListaObjetoImp: [],
			ListaDocsRelacionados: [],
			ListaConceptosFactura: [],
			ObjCotizacion: {},
			RutaDeOrigen: '',
			DataCliente: '',
			NumeroTimbres: 0,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;

			let formData = new FormData();

			let ApComision = (this.objFactura.AplicaComision == true)?'SI':'NO';
			let ApComisionFlores = (this.objFactura.AplicaComFlor == true)?'SI':'NO';
			let ClavePago = '';
			let FormaPago = '';

			if(this.objFactura.FormaPago!='')
			{
				let separe = this.objFactura.FormaPago.split('~');
				ClavePago = separe[0];
				FormaPago = separe[1];
			}

			formData.set('IdFactura', this.objFactura.IdFactura);
			formData.set('IdCotizacion', this.objFactura.IdCotizacion);
			formData.set('IdCliente', this.objFactura.IdCliente);
			
			formData.set('NombreCliente', this.objFactura.NombreCliente);
			formData.set('RfcCliente', this.objFactura.RfcCliente);
			formData.set('TelCliente', this.objFactura.TelCliente);
			formData.set('CorreoCliente', this.objFactura.CorreoCliente);
			formData.set('CalleCliente', this.objFactura.CalleCliente);
			formData.set('ColoniaCliente', this.objFactura.ColoniaCliente);
			formData.set('CiudadCliente', this.objFactura.CiudadCliente);
			formData.set('PaisCliente', this.objFactura.PaisCliente);
			formData.set('EstadoCliente', this.objFactura.EstadoCliente);
			formData.set('MunicipioCliente', this.objFactura.MunicipioCliente);
			formData.set('CPCliente', this.objFactura.CPCliente);
			formData.set('NumExtCliente', this.objFactura.NumExtCliente);
			formData.set('NumIntCliente', this.objFactura.NumIntCliente);

			let Descuento = this.objFactura.Descuento;
			let SubTotal = this.objFactura.SubTotal;
			let Iva = this.objFactura.Iva;
			let PorcentajeIva = this.objFactura.PorcentajeIva;
			let Total = this.objFactura.Total;

			Descuento = (Descuento == '') ? 0 : Descuento;
			SubTotal = (SubTotal == '') ? 0 : SubTotal;
			Iva = (Iva == '') ? 0 : Iva;
			PorcentajeIva = (PorcentajeIva == '') ? (this.objAgenos.ValorIva == '')?0:this.objAgenos.ValorIva : PorcentajeIva;
			Total = (Total == '') ? 0 : Total;

			formData.set('TipoComprobante', this.objFactura.TipoComprobante);
			formData.set('SubTotal', SubTotal);
			formData.set('Descuento', Descuento);
			formData.set('Iva', Iva);
			formData.set('PorcentajeIva', PorcentajeIva);
			formData.set('Total', Total);

			formData.set('ClavePago', ClavePago);
			formData.set('FormaPago', FormaPago);
			formData.set('MetodoPago', this.objFactura.MetodoPago);
			formData.set('CondicionesPago', this.objFactura.CondicionesPago);
			formData.set('NumCtaPago', this.objFactura.NumCtaPago);
			formData.set('Banco', this.objFactura.Banco);
			formData.set('TipoCambio', this.objFactura.TipoCambio);
			formData.set('Moneda', this.objFactura.Moneda);
			formData.set('Simbolo', this.objFactura.Simbolo);
			formData.set('Facturado', this.objFactura.Facturado);
			formData.set('NoProveedor', this.objFactura.NoProveedor);
			formData.set('Adenda', this.objFactura.Adenda);
			formData.set('Observaciones', this.objFactura.Observaciones);
			formData.set('UsoCfdi', this.objFactura.UsoCfdi);
			
			let TipoRelacion = (this.objFactura.TipoRelacion =='')?'':this.objFactura.TipoRelacion;
			formData.set('DiasCredito', this.objFactura.DiasCredito);
			formData.set('Anticipo', this.objFactura.Anticipo);
			formData.set('TipoRelacion', TipoRelacion);
			formData.set('IdDocumentoRelacionado', this.objFactura.IdDocumentoRelacionado);
			formData.set('TipoFacturaMoneda', this.objFactura.TipoFacturaMoneda);
			formData.set('ValorDolar', this.objFactura.ValorDolar);
			formData.set('PorcentajeComision', this.objFactura.PorcentajeComision);
			formData.set('AplicaComision', ApComision);
			formData.set('FacturaPaquete', this.objFactura.FacturaPaquete);
			formData.set('EstatusCancel', this.objFactura.EstatusCancel);
			formData.set('ComisionFlores', this.objFactura.ComisionFlores);
			formData.set('AplicaComFlor', ApComisionFlores);
			formData.set('RetencionIva', this.objFactura.RetencionIva);
			formData.set('RegimenFiscalCliente', this.objFactura.RegimenFiscalCliente);
			formData.set('VersionFact', this.objFactura.VersionFact);
			formData.set('Periodicidad', this.objFactura.Periodicidad);
			formData.set('MesPeriodicidad', this.objFactura.MesPeriodicidad);
			formData.set('AnioPeriodicidad', this.objFactura.AnioPeriodicidad);
			formData.set('Guardar', this.objAgenos.Guardar);
			formData.set('Detalle', JSON.stringify(this.ListaConceptosFactura));

            await this.$http.post('facturas', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
			let obj = {
				message: res.data.message,
				typemsg: res.data.typemsg,
			};
			this.EjecutaMensajeAlerta(obj);
            //this.Regresar();
        },
        EjecutaConError(err)
        {
			this.oBtnSave.DisableBtn = false;
			// console.log(err.response.data)
			// SI DEVUELVE TYPEMSG CORRESPONDE A UN ERROR DE TIMBRADO, SINO CORRESPONDE A UN ERROR DE VALIDACION NORMAL
			if(err.response.data.typemsg)
			{
				this.bus.$emit('RunAlerts_'+this.Emit,3);
				this.EjecutaMensajeAlerta(err.response.data);
			}
			else
			{
				if(err.response.data.errors){
					this.errorvalidacion = err.response.data.errors;
					this.oBtnSave.Toast = 2;
				}
				else{
					this.$toast.error(err.response.data.message);
				}
			}
        },
		EjecutaMensajeAlerta(DataAlert)
		{
			//console.log(DataAlert);
			let Titulo = 'Se produjo un error al timbrar';
			let Mensaje = DataAlert.message;
			let Icon = 'warning';
			let Content = '';

			switch(DataAlert.typemsg)
			{
				case 3:

					let htmls = `
					<h3>Problemas detectados:</h3><br>
					<hr>
					<div class="card scrollCfdi">
						<div class="card-body">
							<ul class="list-group">`;
					
					$.each(DataAlert.errors.Error, function(key, value){
						htmls+=`<li class="list-group-item">`+value+`</li>`;
					});

					htmls+=`</ul>
						</div>
					</div>`;
					Content = htmls;

				break;

				case 1:
					Titulo = 'Facturado Exitosamente';
					Icon = 'success';
				break;

				case 0:
					Titulo = 'Información Guardada Correctamente';
					Icon = 'success';
				break;
			}

			this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">'+Titulo+'</h2>',
                text: Mensaje,
				html: Content,
                icon: Icon,
                confirmButtonText: 'Aceptar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#00a389',
            });
			this.Regresar();
		},
		Recuperar()
        {
            this.$http.get(
                "facturas/"+this.objFactura.IdFactura
            ).then((res) => {
                this.objFactura = res.data.data;
				let response = res.data.detalle;

				response.map(function(element){
					if(parseFloat(element.ImporteRetIva)>0){
						element.RetencionIva = true;
					}
					else{
						element.RetencionIva = false;
					}
				});

                this.ListaConceptosFactura = response;

				let Union = this.objFactura.ClavePago+'~'+this.objFactura.FormaPago;
				this.objFactura.FormaPago = Union;
				this.objFactura.AplicaComision = (this.objFactura.AplicaComision == 'SI') ? true : false;
				this.objFactura.AplicaComFlor = (this.objFactura.AplicaComFlor == 'SI') ? true : false;

				if(this.objFactura.Facturado =='NO'){
					this.oBtnSave.ShowBtnSave = true;
				}
				else{
					this.oBtnSave.ShowBtnSave = false;
				}

				
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
                this.ConfigLoadTable.ShowLoader = false;
				this.EjecutarCalculos();
            });
        },
        Limpiar()
        {
            this.objFactura = {
				IdFactura: 0,
				IdCotizacion: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				IdCliente: 0,
				IdUsuario: 0,
				FechaRegistro: '',
				Folio: '',
				Serie: '',
				NombreEmpresa: '',
				RegimenFiscalEmpresa: '',
				RfcEmpresa: '',
				CalleEmpresa: '',
				TelEmpresa: '',
				ColoniaEmpresa: '',
				CiudadEmpresa: '',
				PaisEmpresa: '',
				EstadoEmpresa: '',
				MunicipioEmpresa: '',
				CPEmpresa: '',
				NumExtEmpresa: '',
				NumIntEmpresa: '',
				NombreCliente: '',
				RfcCliente: '',
				TelCliente: '',
				CorreoCliente: '',
				CalleCliente: '',
				ColoniaCliente: '',
				CiudadCliente: '',
				PaisCliente: '',
				EstadoCliente: '',
				MunicipioCliente: '',
				CPCliente: '',
				NumExtCliente: '',
				NumIntCliente: '',
				TipoComprobante: 'I',
				SubTotal: '',
				Descuento: '',
				Iva: '',
				PorcentajeIva: '',
				Total: '',
				FormaPago: '',
				ClavePago: '',
				MetodoPago: '',
				CondicionesPago: '',
				NumCtaPago: '',
				Banco: '',
				TipoCambio: 1,
				Moneda: '',
				Simbolo: '$',
				Facturado: 'NO',
				NoProveedor: '',
				Adenda: '',
				Observaciones: '',
				UsoCfdi: '',
				DiasCredito: '',
				Anticipo: '',
				TipoRelacion: '',
				IdDocumentoRelacionado: '',
				TipoFacturaMoneda: 'MXN',
				ValorDolar: 0,
				PorcentajeComision: '',
				AplicaComision: '',
				FacturaPaquete: '',
				EstatusCancel: '',
				ComisionFlores: '',
				AplicaComFlor: '',
				RetencionIva: '',
				RegimenFiscalCliente: '',
				VersionFact: '4.0',
				Periodicidad: '',
				MesPeriodicidad: '',
				AnioPeriodicidad: '',
				RegEstatus: 'A',
            }

			this.objAgenos = {
				Guardar: 1,
				FolioCotizacion: '',
				Importe: '',
				RetencionIva: 6,
				ValorRetencion: 0,
				TrasladoIva: 16,
				ValorIva: 0,
				ClaveFloreria: '',
				ClaveMontaje: '',
			}

            this.errorvalidacion = [];
			this.ListaMetodoPago 	= [];
			this.ListaFormaPago 	= [];
			this.ListaUsodeCfdi 	= [];
			this.ListaMonedas 		= [];
			this.ListaTipoRelacion	= [];
			this.ListaClavePyS 		= [];
			this.ListaUnidadMedida 	= [];
			this.ListaObjetoImp 	= [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{pLugar: this.RutaDeOrigen}});
        },
		GetListCombosConfig()
		{
			this.$http.get(
                "getCombosfactura"
            ).then((res) => {
                this.ListaMetodoPago 	= res.data.MetodoPago;
				this.ListaFormaPago 	= res.data.FormaPago;
				this.ListaUsodeCfdi 	= res.data.UsoDeCfdi;
				this.ListaMonedas 		= res.data.Moneda;
				this.ListaTipoRelacion	= res.data.TipoRelacion;
				this.ListaClavePyS 		= res.data.ClavePyS;
				this.ListaUnidadMedida 	= res.data.UnidadMedida;
				this.ListaObjetoImp 	= res.data.ObjetoImp;

				let Impuesto = res.data.Impuestos;
				let Conceptos = res.data.ConceptosFYM;
				let Own = this;

				Impuesto.map(function(element){
					if(element.Nombre == 'Retencion IVA')
					{
						Own.objAgenos.RetencionIva = element.Impuesto;
						Own.objAgenos.ValorRetencion = element.ValorImpuesto
					}
					else
					{
						Own.objAgenos.TrasladoIva = element.Impuesto;
						Own.objAgenos.ValorIva = element.ValorImpuesto;
					}
				});

				Conceptos.map(function(element){
					if(element.Tipo == 'F'){
						Own.objAgenos.ClaveFloreria = element.CodigoSat;
					}else{
						Own.objAgenos.ClaveMontaje = element.CodigoSat;
					}
				});

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
				this.GetTimbresDisponibles();
            });
		},
		GetTimbresDisponibles()
		{
			this.$http.get(
                "getTimbresfactura"
            ).then((res) => {
				//console.log(res.data)
				this.NumeroTimbres = res.data.timbres;
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
		GetConceptosCotizacion()
		{
			this.ConfigLoadTable.ShowLoader = true;
			this.$http.get("getConceptosCotz",{
				params:{
					TipoMoneda: this.objFactura.TipoFacturaMoneda,
                    IdCotizacion: this.ObjCotizacion.IdCotizacion,
                }
			}).then((res) => {
				//console.log(res.data.data);
				let ArregloConceptos = [];

				res.data.data.map(function(element){
					let obj = {
						IdFactura: 0,
						IdDetalleFactura: 0,
						IdCotizacion: element.IdCotizacion,
						IdDetalleCotizacion: element.IdDetalleCotizacion,
						Cantidad: element.Cantidad,
						ClaveProdServ: '',
						Unidad: '',
						ClaveObjImpuesto: '',
						Descripcion: element.Descripcion,
						Precio: element.Precio,
						Descuento: 0,
						Importe: '',

						RetencionIva: false,
						PrecioDefault: element.Precio,
						TipoMoneda: element.TipoMoneda,
						TasaRetIva: 0,
						ImporteRetIva: 0,
					};

					ArregloConceptos.push(obj)
				});

				//console.log(ArregloConceptos);
				this.ListaConceptosFactura = ArregloConceptos;
				
			}).finally(()=>{
                this.ConfigLoadTable.ShowLoader = false;
				this.EjecutarCalculos();
            });
		},
		AbrirModalRelacionadas()
		{
			let obj = {
				IdCliente: this.objFactura.IdCliente,
				RFCcliente: this.objFactura.RfcCliente,
				Agregados: this.ListaDocsRelacionados,
			}
			this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
		},
		AgregarRelacionadas(item)
		{
			let obj = {
				IdFactura: item.IdFactura,
				TipoDocumento: 'F',
				UUID: item.UUID,
				TipoDeRelacion: this.objFactura.TipoRelacion,
			};

			this.ListaDocsRelacionados.push(obj);

			this.objFactura.TipoRelacion = '';
		},
		BorrarRelacionadas(){
			this.ListaDocsRelacionados = [];
		},
		BorrarItemRelacionada(index){
			this.ListaDocsRelacionados.splice(index, 1);
		},
		AgregarConcepto()
		{
			let obj = {
				IdFactura: 0,
				IdDetalleFactura: '',
				IdCotizacion: this.ObjCotizacion.IdCotizacion,
				IdDetalleCotizacion: 0,
				Cantidad: '',
				ClaveProdServ: '',
				Unidad: '',
				ClaveObjImpuesto: '',
				Descripcion: '',
				Precio: '',
				Descuento: 0,
				Importe: '',

				RetencionIva: false,
				PrecioDefault: 0,
				TipoMoneda: 'MXN',
				TasaRetIva: 0,
				ImporteRetIva: 0,
			};

			this.ListaConceptosFactura.push(obj);
		},
		BorrarItemConcepto(index)
		{
			this.ListaConceptosFactura.splice(index, 1);
			this.EjecutarCalculos();
		},
		SetearDataCliente()
		{
			if(this.objFactura.IdFactura == 0)
			{
				this.objFactura.IdCotizacion = this.ObjCotizacion.IdCotizacion;
				this.objFactura.IdCliente = this.ObjCotizacion.IdAgente;
				this.ImplementarDataCliente(this.ObjCotizacion.Agente);

				this.GetConceptosCotizacion();
			}
			
			this.objAgenos.FolioCotizacion = this.ObjCotizacion.Folio;
		},
		ImplementarDataCliente(objCliente)
		{
			let comision = objCliente.DescuentoFlor;
			this.objFactura.NombreCliente = objCliente.RazonSocial;
			this.objFactura.RfcCliente = objCliente.RFC;
			this.objFactura.TelCliente = objCliente.Telefono;
			this.objFactura.CorreoCliente = objCliente.Email;
			this.objFactura.CalleCliente = objCliente.Calle;
			this.objFactura.ColoniaCliente = objCliente.Colonia;
			this.objFactura.CiudadCliente = objCliente.Municipio;
			this.objFactura.PaisCliente = objCliente.Pais;
			this.objFactura.EstadoCliente = objCliente.Estado;
			this.objFactura.MunicipioCliente = objCliente.Municipio;
			this.objFactura.CPCliente = objCliente.CP;
			this.objFactura.NumExtCliente = objCliente.NumExt;
			this.objFactura.NumIntCliente = objCliente.NumInt;
			this.objFactura.PorcentajeComision = objCliente.Comision;
			this.objFactura.ComisionFlores = (!parseFloat(comision))?0:comision;
			this.objFactura.RegimenFiscalCliente = objCliente.RegimenFiscal;
			this.objFactura.DiasCredito = objCliente.DiasCredito;
		},
		RefrescarDataCliente()
		{
			this.ConfigLoad.ShowLoader = true;
			this.$http.get(
				"agentes/"+this.objFactura.IdCliente
            ).then((res) => {
                let dataCliente = res.data.data;
				this.ImplementarDataCliente(dataCliente);
            }).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});
		},
        EjecutarCalculos()
        {
			let SubTotal = 0;
			let ImporteTotal = 0;
            let Iva = this.objAgenos.ValorIva;
            let RetencionP = this.objAgenos.ValorRetencion;
            let Total = 0;
			let TotalRetencion = 0;
			let TotalDescuento = 0;
            let Arreglo = this.ListaConceptosFactura;
           

            for(let i=0; i<Arreglo.length; i++)
            {
				let ValorRetencion = 0;
				let ValorDescuento = 0;

				if(Arreglo[i].RetencionIva){
					ValorRetencion = RetencionP;
				}
				if(Arreglo[i].Descuento>0){
					ValorDescuento = parseFloat(Arreglo[i].Descuento);
				}

                let Cantidad = Arreglo[i].Cantidad;
                let PrecioUn = Arreglo[i].Precio;

				Cantidad = (Cantidad!='') ? Cantidad : 0;
				PrecioUn = (PrecioUn!='') ? PrecioUn : 0;

                Cantidad = (isNaN(Cantidad)) ? 0 : parseFloat(Cantidad);
                PrecioUn = (isNaN(PrecioUn)) ? 0 : parseFloat(PrecioUn);

				let Importe = parseFloat(Cantidad*PrecioUn);
				Importe = (isNaN(Importe)) ? 0 : parseFloat(Importe);
				Arreglo[i].Importe = Importe.toFixed(2);

				// SUMA DE TODOS LOS IMPORTES DA EL SUBTOTAL
                SubTotal+= Importe;

				// SE SUMAN TODOS LOS DESCUENTOS
				TotalDescuento+= ValorDescuento;

				// CALCULAMOS LA RETENCION POR PARTIDA
				// IMPORTE - DESCUENTOS INDIVIDUALES * PORCENTAJE DE LA RETENCION
				let IvaRetencion = parseFloat(Importe-ValorDescuento)*parseFloat(ValorRetencion);
				IvaRetencion = (isNaN(IvaRetencion)) ? 0 : IvaRetencion;
				TotalRetencion+= IvaRetencion;
				
				if(Arreglo[i].TasaRetIva != undefined){
					Arreglo[i].TasaRetIva = ValorRetencion;
					Arreglo[i].ImporteRetIva = IvaRetencion;
				}
            }

			// EL SUBTOTAL ES LA SUMA DE TODOS LOS IMPORTES
            TotalDescuento = (isNaN(TotalDescuento)) ? 0 : TotalDescuento;
            SubTotal = (isNaN(SubTotal)) ? 0 : SubTotal;

			// EL IMPORTE ES EL SUBTOTAL MENOS LOS DESCUENTOS
			ImporteTotal = parseFloat(SubTotal)-parseFloat(TotalDescuento);
			ImporteTotal = (isNaN(ImporteTotal)) ? 0 : ImporteTotal;

			// EL IVA ES EL IMPORTE POR EL PORCENTAJE DE IVA
            Iva = parseFloat(ImporteTotal)*parseFloat(Iva);
            Iva = (isNaN(Iva)) ? 0 : Iva;
            Total = parseFloat(ImporteTotal)+parseFloat(Iva)-parseFloat(TotalRetencion);

			//this.objEvento.Iva 			= 16;
            this.objFactura.Descuento	= parseFloat(TotalDescuento).toFixed(2);
            this.objFactura.SubTotal	= parseFloat(SubTotal).toFixed(2);
			this.objAgenos.Importe		= parseFloat(ImporteTotal).toFixed(2);
            this.objFactura.Iva 		= parseFloat(Iva).toFixed(2);
            this.objFactura.Total		= parseFloat(Total).toFixed(2);
            this.objFactura.RetencionIva= parseFloat(TotalRetencion).toFixed(2);
        },
		CalculaTipoCambioUsd()
		{
			let CambioUsd 		= this.objFactura.ValorDolar; // tipo de cambio
			let Comision 		= this.objFactura.PorcentajeComision;
			let ComisionFlor 	= this.objFactura.ComisionFlores;
			let ChkComision 	= this.objFactura.AplicaComision;
			let ChkComisionFlor = this.objFactura.AplicaComFlor;
			let PrecioArr 		= this.ListaConceptosFactura;

			if(CambioUsd == ''){
				CambioUsd = 0;
			}
			if(Comision == ''){
				Comision = 0;
			}
			if(ComisionFlor == ''){
				ComisionFlor = 0;
			}

			if(CambioUsd>=0)
			{
				for(let i=0; i<PrecioArr.length; i++)
				{
					let ValorComision = 0;
					let ClavePyS = PrecioArr[i].ClaveProdServ;
					let Resultado = PrecioArr[i].PrecioDefault;
					let TipoMoneda = PrecioArr[i].TipoMoneda;

					// SI EL PRECIO DEFAULT ES VACIO O 0 TOMAMOS EL INTRODUCIDO
					if(Resultado=='' || Resultado<=0){
						Resultado = PrecioArr[i].Precio;
						PrecioArr[i].PrecioDefault = Resultado;
					}

					if(TipoMoneda == 'USD' && CambioUsd>0)
					{
						let Importe = PrecioArr[i].PrecioDefault;
						Resultado = parseFloat(Importe)*parseFloat(CambioUsd)
					}

					let CalDescuento = 0;
					if(ChkComision == true && ClavePyS != this.objAgenos.ClaveFloreria)
					{
						ValorComision = parseFloat(Comision);
						if(parseFloat(ValorComision)>0)
						{
							let descuento = parseFloat(ValorComision)/100;
							CalDescuento = parseFloat(descuento)*parseFloat(Resultado);
						}
					}

					if(ClavePyS == this.objAgenos.ClaveFloreria && ChkComisionFlor == true)
					{
						ValorComision = parseFloat(ComisionFlor);
						if(parseFloat(ValorComision)>0)
						{
							let descuento = parseFloat(ValorComision)/100;
							CalDescuento+= parseFloat(descuento)*parseFloat(Resultado);
						}
					}

					Resultado = parseFloat(Resultado)-parseFloat(CalDescuento);
					Resultado = (isNaN(Resultado))? 0 : Resultado;
					PrecioArr[i].Precio = Resultado;
				}
			}
			else
			{
				for(let i=0; i<PrecioArr.length; i++)
				{
					let Importe = PrecioArr[i].PrecioDefault;
					let ClavePyS = PrecioArr[i].ClaveProdServ;

					if(ChkComision == true && parseFloat(Comision)>0 && ClavePyS != this.objAgenos.ClaveFloreria)
					{
						let descuento = parseFloat(Comision)/100;
						let CalDescuento = parseFloat(descuento)*parseFloat(Importe);
						Importe = parseFloat(Importe)-parseFloat(CalDescuento);
					}

					if(ChkComisionFlor == true && parseFloat(ComisionFlor)>0 && ClavePyS == this.objAgenos.ClaveFloreria)
					{
						let descuento = parseFloat(ComisionFlor)/100;
						let CalDescuento = parseFloat(descuento)*parseFloat(Importe);
						Importe = parseFloat(Importe)-parseFloat(CalDescuento);
					}

					Importe = (isNaN(Importe)) ? 0 : Importe;
					PrecioArr[i].Precio = Importe;
				}
			}

			this.EjecutarCalculos();
		},
		SetearACredito()
		{
			let Condicion = this.objFactura.CondicionesPago;

			if(Condicion == 'CREDITO')
			{
				let Metodo =  this.ListaMetodoPago.filter(function(element){
					if(element.Clave == 'PPD'){
						return element;
					}else{
						return '';
					}
				});

				if(Metodo[0]){
					this.objFactura.MetodoPago = Metodo[0].Clave+'~'+Metodo[0].Nombre;
				}

				let Forma =  this.ListaFormaPago.filter(function(element){
					if(element.Clave == '99'){
						return element;
					}else{
						return '';
					}
				});

				if(Forma[0]){
					this.objFactura.FormaPago = Forma[0].Clave+'~'+Forma[0].Nombre;
				}
			}
			else
			{
				this.objFactura.MetodoPago = '';
				this.objFactura.FormaPago = '';
			}
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('AgregarFacturas');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
		this.GetListCombosConfig();
		

		if(this.Id!=''){
            this.objFactura.IdFactura = this.Id;
		}

		if(this.Obj!=undefined){
			this.RutaDeOrigen = this.Obj.Lugar;
			this.ObjCotizacion = this.Obj.objCotz;
			this.SetearDataCliente();
		}

		/* let ObjCotizacion = JSON.parse(sessionStorage.getItem('objCotizacion'));
		this.objFactura.IdCotizacion = ObjCotizacion.IdCotizacion;
 */
        if(this.objFactura.IdFactura>0)
        {
            this.objFactura.IdFactura = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
			this.oBtnSave.ShowBtnSave = true;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('AgregarFacturas',(obj)=>
        {
            this.AgregarRelacionadas(obj);
        });
    }
}
</script>
